import { render } from "./Show.vue?vue&type=template&id=0de4e461"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
script.render = render

export default script